import { urlApiDiscussion } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponseCanvas } from '~/utils/interface/base';
import {
  IBodyMarkReadAllEntries,
  IBodyUpdateEntry,
  IDiscussionDetail,
  IDiscussionEntry,
  IQueryDeleteEntry,
  IQueryGetDiscussionDetail,
  IQueryGetDiscussionEntries,
  IQueryGetFullDiscussionEntries,
} from '~/utils/interface/discussion';
import { ContentTypeEnum } from '~/utils/enum/common';

export const discussionApi = {
  getDetailDiscussion(params: IQueryGetDiscussionDetail) {
    return axiosClient.get<IBaseResponse<IDiscussionDetail>>(urlApiDiscussion.detail, { params });
  },

  getDiscussionEntries(params: IQueryGetDiscussionEntries) {
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<IDiscussionEntry[]>>>(urlApiDiscussion.getEntries, {
      params,
    });
  },

  getFullDiscussionEntries(params: IQueryGetFullDiscussionEntries) {
    return axiosClient.get<IBaseResponse<IDiscussionEntry[]>>(urlApiDiscussion.getFullEntries, {
      params,
    });
  },

  createEntry(body: FormData) {
    return axiosClient.post<IBaseResponse<IDiscussionEntry>>(urlApiDiscussion.createEntry, body, {
      headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
    });
  },

  updateEntry(body: IBodyUpdateEntry) {
    return axiosClient.put<IBaseResponse<IDiscussionEntry>>(urlApiDiscussion.createEntry, body);
  },

  createReply(body: FormData) {
    return axiosClient.post<IBaseResponse<IDiscussionEntry>>(urlApiDiscussion.createReply, body, {
      headers: { 'Content-Type': ContentTypeEnum.FORM_DATA },
    });
  },

  deleteEntry(params: IQueryDeleteEntry) {
    return axiosClient.delete<IBaseResponse<any>>(urlApiDiscussion.getEntries, { params });
  },

  markReadAllEntries(body: IBodyMarkReadAllEntries) {
    return axiosClient.put<IBaseResponse<any>>(urlApiDiscussion.markReadAllEntries, body);
  },
};
